module.exports = __webpack_public_path__ + "img/default_avatar.4118ca4f.jpeg";